module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      'logo' ]
  }, [_c('span', {
    staticClass: "logo__inner"
  }, [_c('image-brand-logo', {
    staticClass: "logo__image"
  }), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.label))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67c9e702"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Logo.vue
// module id = 265
// module chunks = 2